module.exports = __webpack_public_path__ + "static/img/7.c3fa4ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/7.png
// module id = jp+J
// module chunks = 0